import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseAnpHistoricalPricesProps<T> = {
  filters?: {
    reportId?: string;
    productId?: string | number;
    geoCityId?: string;
    page?: number;
  };
  mapper?: (data: any) => T;
};

export const useAnpHistoricalPrices = <T,>({
  filters: {
    reportId,
    productId,
    geoCityId,
    page,
  } = {},
  mapper = Mapper.default<T>(),
}: UseAnpHistoricalPricesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['anpHistoricalPrices', reportId, productId, geoCityId, page],
    enabled: Boolean(reportId),
    queryFn: () => privateAxios.get('/anp/historical_prices', {
      params: {
        page,
        'q[report_id_eq]': reportId,
        'q[product_id_eq]': productId,
        'q[geo_city_id_eq]': geoCityId,
      },
    }),
    select: (response: { data: { data: any[]; meta: MetaResponse; }; }) => ({
      data: mapper(response?.data?.data ?? []),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
